import React from 'react';
import { Tag } from '../../types/tags';

interface TagDisplayProps {
	tag: Tag;
	className?: string;
	style?: React.CSSProperties;
	showassociatedPartsCount?: boolean;
	darkMode?: boolean;
}

const TagDisplay: React.FC<TagDisplayProps> = ({
	tag,
	className = '',
	style = {},
	showassociatedPartsCount = false,
	darkMode = false,
}) => {
	return (
		<div
			className={` bodyregular flex items-center justify-between text-black/45  ${className}`}
			style={style}
		>
			<div className="flex items-center gap-2">
				<span
					className="inline-block h-3 w-3 flex-shrink-0 rounded-full"
					style={{
						backgroundColor: tag.color,
						borderWidth: darkMode ? 1 : 0,
						borderColor: darkMode ? '#F0F0F0' : 'transparent',
						borderStyle: darkMode ? 'solid' : 'none',
					}}
				/>
				<span className={`${darkMode ? 'text-grey-4' : ''}`}>{tag.label}</span>
			</div>
			{showassociatedPartsCount && typeof tag.associatedPartsCount === 'number' ? (
				<span className=" text-black/45">({tag.associatedPartsCount})</span>
			) : null}
		</div>
	);
};

export default TagDisplay;
